
import { inject } from '@angular/core';
import { HttpInterceptorFn, HttpRequest, HttpHandlerFn, HttpErrorResponse, HttpContextToken } from '@angular/common/http';
import { catchError, switchMap } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { TokenService } from '../../services/tokens/tokens.service';
import { AuthService } from '../../../features/auth/service/auth.service';
// import { Router } from '@angular/router';
// import { NotificationService } from '../../services/notification/notification.service';
// import { TokenService } from '../services/token.service';
// import { NotificationService } from '../services/notification.service';
// import { AuthService } from '../services/auth.service';

// Context token to skip authentication (e.g., for S3 uploads)
export const SKIP_AUTH = new HttpContextToken<boolean>(() => false);

export const authInterceptor: HttpInterceptorFn = (req: HttpRequest<unknown>, next: HttpHandlerFn) => {
  const tokenService = inject(TokenService);
  const authService = inject(AuthService);
  // const router = inject(Router);
  // const notificationService = inject(NotificationService);
  const token = tokenService.getToken();
  let authReq = req;
  
  // Skip adding Authorization header if context says so (e.g., for S3 uploads)
  const skipAuth = req.context.get(SKIP_AUTH);
  
  
  if (token?.accessToken && !skipAuth) {
    authReq = req.clone({
      setHeaders: {
        Authorization: `${token.tokenType} ${token.accessToken}`
      }
    });
  } 
  
  return next(authReq).pipe(
    catchError((error: HttpErrorResponse) => {
      // if (error.status === 403) {
      //   notificationService.clearAll();
      //   setTimeout(() => router.navigate(['/403']), 50);
      //   return throwError(() => error);
      // }
      if (error.status === 401) {
        // Skip refresh if already calling refresh endpoint
        if (req.url.includes('/auth/refresh')) {
          authService.doLogout();
          return throwError(() => error);
        }
        // Skip logout for password change endpoint - let component handle the error
        if (req.url.includes('/profile/change-password') || req.url.includes('/password')) {
          return throwError(() => error);
        }
        // Skip refresh attempt when the logout call itself gets a 401
        if (req.url.includes('/auth/logout')) {
          return throwError(() => error);
        }
        const refreshToken = token?.refreshToken;
        if (!refreshToken) {
          // Only logout if we actually had a token — avoids loop when already logged out
          if (token) {
            authService.doLogout();
          }
          return throwError(() => error);
        }
        // Attempt to refresh token
        return authService.getNewAccessToken(refreshToken).pipe(
          switchMap((res) => {
            tokenService.setToken({
              accessToken: res?.data?.access_token,
              refreshToken: res?.data?.refresh_token,
              expiresIn: res?.data?.expires_in,
              tokenType: res?.data?.token_type
            });
            const newToken = tokenService.getToken();
            const retryReq = req.clone({
              setHeaders: {
                Authorization: `${newToken?.tokenType} ${newToken?.accessToken}`
              }
            });
            return next(retryReq);
          }),
          catchError(refreshError => {
            authService.doLogout();
            return throwError(() => refreshError);
          })
        );
      }
      // Other errors
      return throwError(() => error);
    })
  );
};
